import axios from "axios";

export default axios.create({
  baseURL: "https://aeonlms.aeonsoftware.net/cit",
});
